import React from 'react';
import { Box } from '@mui/material';

const LoadingPage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'gray',
        opacity: '0.2',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
      }}
    >
    </Box>
  );
};

export default LoadingPage; 